// 全屏
import screenfull from 'screenfull'
// 切换全屏
export function setWindowFullScreen() {
    screenfull.toggle()
   if(screenfull.isFullscreen){
       return true
   }
   return false
}
